import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  //
  detailPegawaiChannel = new Subject();
  gradeChannel = new Subject();
  updateGradeChannel = new Subject();
  updateSkpChannel = new Subject();
  updatePenilaianChannel = new Subject();
  recalculationChannel = new Subject();

  createChannel = new Subject();
  detailChannel = new Subject();
  repository = new CreateRepository();
  employeeChannel = new Subject();
  rankChannel = new Subject();
  listPresensiChannel = new Subject();
  typeChannel = new Subject();
  deletePresensi = new Subject();
  generatePresensi = new Subject();
  updateJabatan = new Subject();
  listJabatanChannel = new Subject();
  individualCriteriaChannel = new Subject();
  listComponentChannel = new Subject();
  listComponentHistoryChannel = new Subject();
  listCriteriaChannel = new Subject();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.individualCriteriaChannel.next({ status: apiResponse.INITIAL })
    this.listComponentChannel.next({ status: apiResponse.INITIAL });
    this.listComponentHistoryChannel.next({ status: apiResponse.INITIAL });
    this.listCriteriaChannel.next({ status: apiResponse.INITIAL });
    //this.listPresensiChannel.next({status: apiResponse.INITIAL})
  }

  fetchDetailPegawai = async (query) => {
    try {
      this.detailPegawaiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchdetailPegawaiChannel(query)
        .then((result) => {
          this.detailPegawaiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailPegawaiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchGrade = async (query) => {
    try {
      this.gradeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGrade(query)
        .then((result) => {
          this.gradeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.gradeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  updateGrade = async (query) => {
    try {
      this.updateGradeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .updateGrade(query)
        .then((result) => {
          this.updateGradeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateGradeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  updateSkp = async (query) => {
    try {
      this.updateSkpChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .updateSkp(query)
        .then((result) => {
          this.updateSkpChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateSkpChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  updatePenilaian = async (query) => {
    try {
      this.updatePenilaianChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .updatePenilaian(query)
        .then((result) => {
          this.updatePenilaianChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updatePenilaianChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  recalculationRevision = async (query) => {
    try {
      this.recalculationChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .recalculationRevision(query)
        .then((result) => {
          this.recalculationChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.recalculationChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchEmployee = async (query) => {
    try {
      this.employeeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployee(query)
        .then((result) => {
          this.employeeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  fetchRank = async (query) => {
    try {
      this.rankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRank(query)
        .then((result) => {
          this.rankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rankChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  fetchType = async (query) => {
    try {
      this.typeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchType(query)
        .then((result) => {
          this.typeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.typeChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchDetail = async (query) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetail(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  fetchListPresensi = async (query) => {
    try {
      this.listPresensiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchListPresensi(query)
        .then((result) => {
          this.listPresensiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listPresensiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchDeletePresensi = async (query) => {
    try {
      this.deletePresensi.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDeletePresensi(query)
        .then((result) => {
          this.deletePresensi.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.deletePresensi.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchGeneratePresensi = async (query) => {
    try {
      this.generatePresensi.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGeneratePresensi(query)
        .then((result) => {
          this.generatePresensi.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.generatePresensi.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  fetchUpdateJabatan = async (query) => {
    try {
      this.updateJabatan.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdateJabatan(query)
        .then((result) => {
          this.updateJabatan.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateJabatan.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };
  fetchListJabatan = async (query) => {
    try {
      this.listJabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchListJabatan(query)
        .then((result) => {
          this.listJabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listJabatanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchIndividualCriteria = async (query) => {
    try {
      this.individualCriteriaChannel.next({ status: apiResponse.LOADING })
      await this.repository.fetchIndividualCriteria(query).then((result) => {
        this.individualCriteriaChannel.next({ status: apiResponse.COMPLETED, data: result })
      }).catch((error) => {
        this.individualCriteriaChannel.next({ status: apiResponse.ERROR, data: error })
      })
    } catch (error) {
      console.log('unsubscribe')
    }
  }

  fetchComponent = async (query) => {
    this.listComponentChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchComponent(query)
      .then((result) => {
        this.listComponentChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.listComponentChannel.next({
          status: apiResponse.ERROR,
          data: error,
        });
      });
  };
  fetchComponentHistory = async (query) => {
    this.listComponentHistoryChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchComponentHistory(query)
      .then((result) => {
        this.listComponentHistoryChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.listComponentHistoryChannel.next({
          status: apiResponse.ERROR,
          data: error,
        });
      });
  };

  fetchCriteria = async (query) => {
    this.listCriteriaChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchCriteria(query)
      .then((result) => {
        this.listCriteriaChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.listCriteriaChannel.next({
          status: apiResponse.ERROR,
          data: error,
        });
      });
  };
}

export default CreateBloc;
